<div class="row-itens col-xs-12" *ngIf="!isPanel">
  <span class="title">Produtos: </span>
  <button
      type="button"
      class="btn btn-primary radius"
      [ngClass]="{'active': isAllSelected}"
      (click)="selectAll()"
      [disabled]="disabled">TODOS
  </button>

  <label
      class="btn radius"
      [ngClass]="{'active': produto.checked, 'deactive': disabled}"
      *ngFor="let produto of produtos">
    <input
        class="btn-input-checkbox"
        type="checkbox"
        [(ngModel)]="produto.checked"
        [name]="produto.descricao"
        (click)="select($event, produto)"
        [disabled]="disabled">
    <span>{{ produto.descricao }}</span>
  </label>
</div>

<!-- PANEL (RANKING e DESEMPENHO) -->
<app-panel *ngIf="isPanel">
  <app-btn-group title="Produtos">
    <button
        type="button"
        class="btn btn-primary"
        [ngClass]="{ 'active': isAllSelected }"
        (click)="selectAll()"
        [disabled]="isAllSelected">TODOS
    </button>

    <label
        class="btn"
        [ngClass]="{'active': produto.checked, 'deactive': disabled}"
        *ngFor="let produto of produtos">
      <input
          class="btn-input-checkbox produto-selector"
          type="checkbox"
          [(ngModel)]="produto.checked"
          [name]="produto.descricao"
          (click)="select($event, produto)"
          [disabled]="disabled">
      <span>{{ produto.descricao }}</span>
    </label>
  </app-btn-group>
</app-panel>
